import { render, staticRenderFns } from "./JobItemSelect.vue?vue&type=template&id=afd2b6d8&"
import script from "./JobItemSelect.vue?vue&type=script&lang=js&"
export * from "./JobItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports